import React from "react";
import { arrayOf, string, bool } from "prop-types";
import { Table, Box } from "@mui/material";

import { tabKeyType } from "../constants/proptypes";
import AnalysesTableHeaderRow from "./table/AnalysesTableHeaderRow";
import AnalysesTableDataRow from "./table/AnalysesTableDataRow";
import AnalysesTableStatusRow from "./table/AnalysesTableStatusRow";
import LoginButton from "shared/chrome/LoginButton";
import ProgressIndicator from "./ProgressIndicator";
import { trackPageView } from "../hooks/usePageView";

class AnalysesTable extends React.PureComponent {
  handleSubmit = (e) => {
    e.preventDefault();
  };

  determinePageTitle() {
    switch (this.props.activeTabKey) {
      case "compare-your-own-pricing":
        return "Compare Your Own Pricing";
      case "icer-pricing":
        return "ICER Pricing";
      case "drugs":
        return "Drugs List";
      case "report-snapshots":
        return "Report Snapshots";
      default:
        return "Analysis";
    }
  }

  trackPageView() {
    !this.props.loading && trackPageView(this.determinePageTitle());
  }

  componentDidMount() {
    this.trackPageView();
  }

  componentDidUpdate() {
    this.trackPageView();
  }

  render() {
    const { activeTabKey, rowIds, loading, searchTerm } = this.props;
    const errorBoxStyles = {
      minWidth: "100%",
      minHeight: "300px",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "15px",
    };

    if (loading) {
      return (
        <Box sx={errorBoxStyles}>
          <ProgressIndicator active={loading} />
        </Box>
      );
    }
    if (activeTabKey !== "compare-your-own-pricing" && !rowIds.length && !searchTerm) {
      return (
        <Box sx={errorBoxStyles}>
          <p>
            We&apos;re having trouble loading analyses. Thanks for your patience.
            <br /> Please try logging in again.
          </p>
          <LoginButton />
        </Box>
      );
    }
    return (
      <form
        className="analyses"
        onSubmit={this.handleSubmit}
        style={{
          width: "100%",
          flex: "1 1 auto",
          overflow: "auto",
          overflowX: "auto",
          overflowY: "auto",
          position: "relative",
          boxSizing: "border-box",
          minWidth: 0,
          minHeight: 0,
        }}
      >
        <Table sx={{ minWidth: "100%", tableLayout: "auto" }}>
          <AnalysesTableHeaderRow activeTabKey={activeTabKey} />
          {rowIds.map((analysisId) => (
            <AnalysesTableDataRow key={analysisId} analysisId={analysisId} />
          ))}
          <AnalysesTableStatusRow rowIds={rowIds} />
        </Table>
      </form>
    );
  }
}

AnalysesTable.propTypes = {
  activeTabKey: tabKeyType.isRequired,
  rowIds: arrayOf(string).isRequired,
  loading: bool.isRequired,
  searchTerm: string,
};

export default AnalysesTable;
